/**
 * 'Http.service'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
import axios from 'axios'
import auth from './auth.service'
import httpErrorNotification from './http-error-notification.service'
// TODO Eliminar cuando quede el certificado
import https from 'https'

const http = axios.create({
  baseURL: process.env.API_URL
})

/**
 * Add functionality on each request made
 * to the API
 */
http.interceptors.request.use(
  function (config) {
    config.headers = {
      authorization: auth.token()
    }
    // TODO Eliminar cuando quede el certificado
    config.httpsAgent = new https.Agent({
      rejectUnauthorized: false
    })
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

/**
 * Add functionality on each response made
 * to the API
 */
http.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (httpError) {
    // Do something with response error
    httpErrorNotification(httpError.response)
    return Promise.reject(httpError)
  }
)

export default http



// WEBPACK FOOTER //
// ./src/services/http.service.js